import api from '@/lib/api'

export interface OrganizationMember {
  id: string
  name: string
  email: string
  avatar?: string
  org_role?: string
}

export interface OrganizationInvite {
  id: string
  email: string
  role: string
  status: string
  createdAt: string
  expiresAt: string
}

export const organizationService = {
  getMembers: async () => {
    const response = await api.get<{
      members: OrganizationMember[]
      invites: OrganizationInvite[]
    }>('/marketer/organization/members')
    return response.data
  },

  inviteMember: async (email: string, role: string = 'member') => {
    const response = await api.post('/marketer/organization/invite', { email, role })
    return response.data
  },

  revokeInvite: async (invitationId: string) => {
    const response = await api.delete(`/marketer/organization/invitations/${invitationId}`)
    return response.data
  },
}
